import { combineReducers } from "redux-immutable";
import { fromJS } from "immutable";
import { LOCATION_CHANGE } from "react-router-redux";
import loginReducer from "./login/reducers";
import usersReducer from "./users/reducers";
import groupsReducer from "./usersGroup/reducers";
import departmentReducer from "./department/reducers";
import powerbiReducer from "./powerBi/reducers";
import logsReducer from "./logs/reducers";
import common from "./common/reducers";

/*
 * routeReducer
 *
 * The reducer merges route location changes into our immutable state.
 * The change is necessitated by moving to react-router-redux@4
 *
 */

// Initial routing state
const routeInitialState = fromJS({
  location: null,
});

/**
 * Merge route into the global application state
 */
/*
export function routeReducer(state = routeInitialState, action) {
  switch (action.type) {
     istanbul ignore next 
    case LOCATION_CHANGE:
      return state.merge({
        location: action.payload,
      });
    default:
      return state;
  }
}
*/
/**
 * Creates the main reducer with the dynamically injected ones
 */
export default function createReducer(injectedReducers) {
  return combineReducers({
    login: loginReducer,
    common,
    users: usersReducer,
    groups: groupsReducer,
    department: departmentReducer,
    test: powerbiReducer,
    logs: logsReducer,
    ...injectedReducers,
  });
}
